import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { useGlobalProducts } from 'components/BusinessToolForm/hooks/useGlobalProducts';
import {
  GLOBAL_PRODUCTS_NAME,
  isJustCreatedFiled,
} from 'components/BusinessToolForm/Sections/Global/form';

export const useCreateFirstProduct = () => {
  const { handleAddProduct } = useGlobalProducts();
  const { getValues, setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  useEffect(() => {
    if (!canAccess) return;
    let ignore = false;
    const createProduct = () => {
      if (ignore) return;
      const isJustCreated = getValues(isJustCreatedFiled);
      const products = getValues(GLOBAL_PRODUCTS_NAME);

      if (isJustCreated && products.length === 1 && products[0].productId === '') {
        setValue(GLOBAL_PRODUCTS_NAME, []);
        handleAddProduct();
        setValue(isJustCreatedFiled, false);
      }
    };
    setTimeout(createProduct, 0);

    return () => {
      ignore = true;
    };
  }, []);
};
